/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Paper, Typography, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import Chart from '../dashboard/Chart';
import { TerritoryMap } from '../territorycard/TerritoryMap';
import { VisitorRecord } from '../territorycard/VisitorRecord';
import { Copyright } from '../dashboard/Copyright';
import { useAuth } from '../../services/cognito';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

type Point = {
  lat: number;
  lng: number;
};

export function Layer2() {
  const { mapLayer1, mapLayer2 } = useParams();
  const { isAuthenticated, tokenReady, token, initialized } = useAuth();

  // 모든 인증 조건이 만족되지 않으면 로딩 표시
  if (!initialized || !isAuthenticated || !tokenReady || !token) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: theme =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Container
        disableGutters
        maxWidth="lg"
        sx={{ mt: 2, mb: 2, pl: 1, pr: 1 }}
      >
        <Grid container spacing={0.5}>
          {/* Chart */}
          {/* <Grid item xs={12}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 240,
              }}
            >
              <Chart />
            </Paper>
          </Grid> */}
          <Grid item xs={12}>
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
              sx={{ ml: 1 }}
            >
              개별 구역카드
            </Typography>
          </Grid>
          {/* Map */}
          <Grid item xs={12}>
            <Paper
              sx={{ p: 2, display: 'flex', flexDirection: 'column' }}
              style={{ padding: 25 }}
            >
              {/* <Orders /> */}
              <TerritoryMap layer1={mapLayer1} layer2={mapLayer2} />
            </Paper>
          </Grid>
          {/* Recent Visitors */}
          <Grid item xs={12}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <VisitorRecord layer1={mapLayer1} layer2={mapLayer2} />
            </Paper>
          </Grid>
        </Grid>
        <Copyright sx={{ pt: 4 }} />
      </Container>
    </Box>
  );
}
